import { useState } from "react";
import { useParams } from "react-router-dom";
import PrescriptionsList from "./PrescriptionsList";
import AddPrescriptions from "./AddPrescriptions";
import ViewPrescription from "./ViewPrescription";
import { useGetPrescriptionHistoryQuery } from "../../../../../../Service/PatientList";
import Loader from "../../../../../../Component/DigitalMarketing/Loader";

const initialState = {
  bloodPressure: "",
  pulseRate: "",
  complanits: "",
  hematoxylinEosins: "",
  prescriptionTitleId: "",
  prescriptionTitle: "",
  prescriptionMaster: [],
  prescriptionTest: [],
};

const Prescriptions = () => {
  const [showAddPrescription, setShowAddPrescription] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [view, setView] = useState(false);
  const [viewPrescription, setViewPrescription] = useState<any>({});
  const { id } = useParams();

  // ✅ Fetch prescription history with cache invalidation
  const {
    data: PrescriptionData,
    isLoading,
    isFetching,
    refetch,
  } = useGetPrescriptionHistoryQuery(id, { refetchOnMountOrArgChange: true });

  if (isLoading || isFetching) {
    return <Loader loading={true} />;
  }

  return (
    <div className="row gap-2" style={{ maxHeight: "70vh" }}>
      <div className="col-3 card ms-2">
        <PrescriptionsList
          data={PrescriptionData}
          setShowAddPrescription={setShowAddPrescription}
          setEditMode={setEditMode}
          setViewPrescription={setViewPrescription}
          setView={setView}
          initialState={initialState}
        />
      </div>

      {(showAddPrescription || editMode) && (
        <div className="col-8 card">
          <AddPrescriptions
            viewPrescription={viewPrescription}
            setView={setView}
            setShowAddPrescription={setShowAddPrescription}
            setEditMode={setEditMode}
            refetch={refetch}
          />
        </div>
      )}

      {view && !showAddPrescription && !editMode && (
        <div className="col-8 card">
          <ViewPrescription viewPrescription={viewPrescription} />
        </div>
      )}
    </div>
  );
};

export default Prescriptions;
